import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { basicStoresListQueries } from '@/services/basicStores/basicStores.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

const useAddStoreInfo = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('createBasicStoreInfo', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: [...basicStoresListQueries.all()] });

      void navigate({ to: '/store-information/basic-stores' });
      await revalidate(['clubBasicInfo', 'availableTime', 'clubSchedule']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};

export default useAddStoreInfo;
